<template>
    <v-select
            dense
            label="Seleccione un profesional"
            :items="therapists"
            v-on:change="setTherapist"
            v-model="selectedTherapist"
            item-text="Name"
            item-value="Id"
    ></v-select>
</template>

<script>
export default {
    name: "TherapistSelect",
    data: () => ({
        selectedTherapist: null,
        therapists: [],
    }),
    methods: {
        setTherapist() {
            //console.info("setTherapist", this.selectedTherapist)
            this.$store.commit("setTherapist", { "therapistId": this.selectedTherapist });
            // Emit after DOM updates so PatientSchedule / TherapistSchedule
            // (v-if) have mounted and registered $root listeners.
            this.$nextTick(() => {
                this.$root.$emit('changedTherapist');
            });
        }
    },
    created: async function () {
        const token = this.$store.getters.token;
        const response = await fetch(this.$store.getters.apiUrl + "/api/v1/therapist/simple-list", {
            method: 'POST',
            headers: new Headers({'Authorization': "Bearer " + token})
        });
        const responseData = await response.json();
        if (response.ok) {
            this.therapists = responseData;
        }
        this.selectedTherapist = this.$store.getters.therapistId;
    },
}
</script>

<style scoped>

</style>
